import SwitchButton from '@/components/buttons/SwitchButton';
import { Card } from 'primereact/card';
import type { Dispatch, SetStateAction } from 'react';
import style from '../../views/group.module.css';
import { cn } from '@/components/ui/cn';
import { TextBodySmall } from '@/components/text/Texts';
import { Column, Row } from '@/components/container/Container';

type Props = {
	image: string;
	title: string;
	description: string;
	onClick?: () => void;
	checked: boolean;
	setChecked: Dispatch<SetStateAction<boolean>>;
	active: boolean;
};

const ProgramCard = ({ onClick, image, title, description, checked, setChecked, active }: Props) => {
	return (
		<Card
			onClick={onClick}
			pt={{
				root: { className: style.programCardContainer },
				body: { className: style.programCardBody },
			}}
		>
			<Column className={cn('gap-3', !active && 'opacity-50')}>
				<Row className="justify-between">
					<img alt="blue car icon" width="32" height="32" src={image} />
					<SwitchButton disabled={!active} checked={checked} setChecked={setChecked} />
				</Row>
				<h1 className="text-primary font-poppins text-xl leading-[24px] font-medium tracking-[0px]">{title}</h1>
				<TextBodySmall className="text-black" text={description} />
			</Column>
		</Card>
	);
};

export default ProgramCard;
